<template>
  <div>
    <award-notice-wrapper/>
<!--    <award-notice />-->
    <div class="px-5 pt-5">
      <template v-if="!enableHideTitleWelcome">
        <div class="break-words survey-title leading-base" ref="info">
          <div
            ref="titleContainer"
            :style="titleStyle"
            class="title text-center text-20 font-bold mb-5 text-center"
            v-html="$bus.survey.titlex"
          ></div>
          <div ref="descContainer" :style="titleStyle" class="desc pb-5 box-border" v-html="desc"></div>
        </div>
      </template>
      <template v-else>
        <div ref="placeholder"></div>
      </template>
      <div class="pb-10 relative van-button--auto" ref="footerContainer">
        <user-amount class="mb-3" />
        <van-button
          class="start-button"
          block
          size="large"
          :disabled="$bus.loading"
          :loading="$bus.loading"
          type="primary"
          @click="startAnswer"
        >
          <span>{{ btnText }}</span>
        </van-button>
        <!-- <div class="copyright">
          <span>调研工厂 提供技术支持</span> |
          <a target="_blank" class="text-medium text-theme-text-gray" href="https://survey.work/s/mZZZZfiJ">举报</a>
        </div> -->
        <div class="banner-wrapper" ref="bannerAd">
          <div id="infoBannerAd"></div>
        </div>
        <!-- 网站协议文案提示 -->
        <DygcFooter class="copyright" isReport v-if="footerStatus" />
      </div>
    </div>
    <div class="cover-box"></div>
  </div>
</template>

<script>
import { defaultsSurveyAttr, busGetters, filterParams } from 'dygc'
import AwardNotice from '@/components/AwardNotice'
import { previewImage } from '../assets/js/preview-image'
import DygcFooter from 'components/dygc-footer-bottom/mobile'
import UserAmount from '@/components/UserAmount'
import { initBannerAdsense } from '../../plugins/adsense'
import AwardNoticeWrapper from './reward/AwardNoticeWrapper.vue'

export default {
  name: 'AnswerInfo',
  components: { AwardNoticeWrapper, UserAmount, AwardNotice, DygcFooter },
  props: {
    footerStatus: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    answerRecoveryAmount() {
      const survey = this.$bus.survey
      if (!survey.otherSetting.enableInterestingAnswer) return 0
      return survey.answerRecoveryAmount
    },
    desc() {
      return this.$bus.survey.welcome || ''
    },
    enableHideTitleWelcome() {
      return this.$bus.survey.otherSetting.enableHideTitleWelcome
    },
    enableInterestingAnswer() {
      return this.$bus.survey.otherSetting.enableInterestingAnswer
    },
    btnText() {
      let otherSetting = this.survey.otherSetting || {}
      const cover = otherSetting.cover || {}
      // 兼容就数据
      return this.$bus.buttonOption.startText || cover.startBtn?.text
    },
    otherSetting() {
      return this.survey.otherSetting || {}
    },
    cover() {
      return this.otherSetting.cover || {}
    },
    titleStyle() {
      const data = this.cover.title || {}
      return filterParams({
        color: data.color,
        fontSize: data.size
      })
    },
    ...busGetters(['survey'])
  },
  methods: {
    startAnswer() {
      this.$bus.onStart()
    },
    initHeight(height = 0) {
      const innerHeight = this.$bus.innerHeight
      let copyrightEl = this.$refs.footerContainer.getElementsByClassName('copyright')[0]
      this.$refs.footerContainer.style.paddingBottom = (copyrightEl ? Math.max(copyrightEl.clientHeight, height) : height) + 20 + 'px'
      const footerContainerHeight = this.$refs.footerContainer.clientHeight
      if (this.enableHideTitleWelcome) {
        const offsetTop = this.$refs.placeholder.offsetTop
        this.$refs.placeholder.style.height = innerHeight - offsetTop - footerContainerHeight + 'px'
        return
      }
      const descOffsetTop = this.$refs.descContainer.offsetTop + 1
      const descMinHeight = innerHeight - descOffsetTop - footerContainerHeight
      this.$refs.descContainer.style.minHeight = descMinHeight + 'px'
      previewImage(this.$refs.info)
    }
  },
  mounted() {
    this.initHeight()
    if (this.$bus.survey.otherSetting.enableAdsense) {
      initBannerAdsense('infoBannerAd', {
        success: () => {
          const el = document.getElementById('infoBannerAd')
          el.addEventListener('resize', () => {
            this.$nextTick(() => {
              this.initHeight(this.$refs.bannerAd.scrollHeight)
            })
          })
          this.$nextTick(() => {
            this.initHeight(this.$refs.bannerAd.scrollHeight)
          })
        }
      })
    }
  }
}
</script>
